import * as React from "react";
import { useTranslation } from "react-i18next";
import { ChevronLeft } from "lucide-react";
import { cn } from "@/lib/utils";

export interface BackButtonHeaderProps {
  title: string;
  onBack: () => void;
  rightSlot?: React.ReactNode;
  className?: string;
}

export function BackButtonHeader({ title, onBack, rightSlot, className }: BackButtonHeaderProps) {
  const { t } = useTranslation();
  return (
    <header
      className={cn("flex items-center gap-3 border-b border-line bg-surface px-4 py-2", className)}
    >
      <button
        type="button"
        onClick={onBack}
        aria-label={t("common.buttons.back.label")}
        className="inline-flex size-9 items-center justify-center rounded-3 border border-line bg-surface text-ink-700 hover:bg-surface-1"
      >
        <ChevronLeft size={18} />
      </button>
      <h1
        className="flex-1 truncate text-[17px] font-semibold text-ink-900"
        style={{ fontFamily: "var(--font-display)" }}
      >
        {title}
      </h1>
      {rightSlot ? (
        <div className="font-mono text-[10.5px] uppercase tracking-[.08em] text-ink-500">
          {rightSlot}
        </div>
      ) : null}
    </header>
  );
}
